import { useAuth0 } from '@auth0/auth0-react';
import { Navigate, useLocation } from 'react-router-dom';

export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading, error } = useAuth0();
  const location = useLocation();

  console.log('Protected Route Debug:', {
    isAuthenticated,
    isLoading,
    error,
    pathname: location.pathname
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-custom-red"></div>
      </div>
    );
  }

  if (error) {
    console.error('Auth0 Error:', error);
    return <Navigate to="/" replace />;
  }

  if (!isAuthenticated) {
    // Store the attempted URL
    sessionStorage.setItem('returnTo', location.pathname);
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}; 